import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { ROUTE_LOGIN } from '../../../navigation/constants';
import LoginBannerImage from '../../../icons/user-screen-banner.png';
import BrandLogo from '../../../icons/logo.svg';
import { clearErrorMessages, clearForgotFlags } from './../actions';
import './styles.scss';
import {
    getForgotPasswordError,
    getForgotPasswordSuccess,
    getVerificationCodeStatus,
    getResetPasswordSuccess,
} from '../selectors';
import ForgotForm from './ForgotForm';
import OtpForm from './OtpForm';
import ResetForm from './ResetForm';

function ForgotPassword({
    forgotPasswordSuccess,
    verificationCodeSet,
    resetPasswordSuccess,
    clearFlags,
}) {
    const history = useHistory();

    useEffect(() => {
        clearFlags();
    }, []);

    useEffect(() => {
        if (resetPasswordSuccess) {
            history.push(ROUTE_LOGIN);
        }
    }, [resetPasswordSuccess]);

    return (
        <Fragment>
            <section className="login-block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 banner-sec">
                            <img src={LoginBannerImage} className="img-fluid" />
                            <p>
                                © Copyright {new Date().getFullYear()} Litterati
                            </p>
                        </div>
                        <div className="col-md-4 login-sec">
                            <div className="logo">
                                <img src={BrandLogo} alt="logo" />
                            </div>
                            {!forgotPasswordSuccess ? (
                                <ForgotForm />
                            ) : (
                                <>
                                    {!verificationCodeSet ? (
                                        <OtpForm />
                                    ) : (
                                        <ResetForm />
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    );
}
ForgotPassword.propTypes = {
    // function to clear error message
    clearErrorState: PropTypes.func.isRequired,
    clearFlags: PropTypes.func,
    forgotPasswordSuccess: PropTypes.bool,
    verificationCodeSet: PropTypes.bool,
    resetPasswordSuccess: PropTypes.bool,
};

ForgotPassword.defaultProps = {
    forgotPasswordSuccess: false,
};

const mapStateToProps = (state) => {
    return {
        errorMessage: getForgotPasswordError(state),
        forgotPasswordSuccess: getForgotPasswordSuccess(state),
        verificationCodeSet: getVerificationCodeStatus(state),
        resetPasswordSuccess: getResetPasswordSuccess(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearErrorState: () => dispatch(clearErrorMessages()),
        clearFlags: () => dispatch(clearForgotFlags()),
    };
};

const ConnectedForgotPassword = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ForgotPassword);

export default ConnectedForgotPassword;
